import { render, staticRenderFns } from "./SiteSpecificTemplates.vue?vue&type=template&id=bd39b9ce&scoped=true"
import script from "./SiteSpecificTemplates.vue?vue&type=script&lang=js"
export * from "./SiteSpecificTemplates.vue?vue&type=script&lang=js"
import style0 from "./SiteSpecificTemplates.vue?vue&type=style&index=0&id=bd39b9ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd39b9ce",
  null
  
)

export default component.exports